const apiUrl = import.meta.env.VITE_API_URL

export const isDevelopmentMode = import.meta.env.MODE === 'development'

export const isStagingEnvironment = Boolean(apiUrl?.includes('staging'))

export const isDemoEnvironment = Boolean(
  apiUrl?.includes('api-admin.demo.mlecp.ru'),
)

export const isProductionMode = Boolean(
  !isStagingEnvironment && apiUrl?.includes('platform.mateline.ru'),
)
